import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
const navigationFooterStyles = xcss({
  position: 'relative'
});

/**
 * __Navigation footer__
 *
 * Allows for customisation of the footer.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
const NavigationFooter = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    padding: "space.100",
    paddingBlockEnd: "space.200",
    xcss: navigationFooterStyles
  }, children);
};
export default NavigationFooter;